export const SEARCH_FILTER_FOR_USER = "SEARCH_FILTER_FOR_USER";

export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";

export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILED = "FETCH_ALL_USERS_FAILED";

export const FETCH_USER_COUNTRY = "FETCH_USER_COUNTRY";
export const FETCH_USER_COUNTRY_SUCCESS = "FETCH_USER_COUNTRY_SUCCESS";
export const FETCH_USER_COUNTRY_FAILED = "FETCH_USER_COUNTRY_FAILED";

export const FETCH_USER_COUNTRY_MOBILE_CODE = "FETCH_USER_COUNTRY_MOBILE_CODE";
export const FETCH_USER_COUNTRY_MOBILE_CODE_SUCCESS =
  "FETCH_USER_COUNTRY_MOBILE_CODE_SUCCESS";
export const FETCH_USER_COUNTRY_MOBILE_CODE_FAILED =
  "FETCH_USER_COUNTRY_MOBILE_CODE_FAILED";

export const FETCH_USER_COUNTRY_JSON_MOBILE_CODE =
  "FETCH_USER_COUNTRY_JSON_MOBILE_CODE";
export const FETCH_USER_COUNTRY_JSON_MOBILE_CODE_SUCCESS =
  "FETCH_USER_COUNTRY_JSON_MOBILE_CODE_SUCCESS";
export const FETCH_USER_COUNTRY_JSON_MOBILE_CODE_FAILED =
  "FETCH_USER_COUNTRY_JSON_MOBILE_CODE_FAILED";

export const FETCH_MOTORCYCLE = "FETCH_MOTORCYCLE";
export const FETCH_MOTORCYCLE_SUCCESS = "FETCH_MOTORCYCLE_SUCCESS";
export const FETCH_MOTORCYCLE_FAILED = "FETCH_MOTORCYCLE_FAILED";

export const FETCH_SINGLE_USER = "FETCH_SINGLE_USER";
export const FETCH_SINGLE_USER_SUCCESS = "FETCH_SINGLE_USER_SUCCESS";
export const FETCH_SINGLE_USER_FAILED = "FETCH_SINGLE_USER_FAILED";

export const USER_ON_BOARDING = "USER_ON_BOARDING";
export const USER_ON_BOARDING_SUCCESS = "USER_ON_BOARDING_SUCCESS";
export const USER_ON_BOARDING_FAILED = "USER_ON_BOARDING_FAILED";

export const CREATE_USER = "CREATE_USER";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAILED = "CREATE_USER_FAILED";

export const REGISTER_CONSENT_FORM = "REGISTER_CONSENT_FORM";
export const REGISTER_CONSENT_FORM_SUCCESS = "REGISTER_CONSENT_FORM_SUCCESS";
export const REGISTER_CONSENT_FORM_FAILED = "REGISTER_CONSENT_FORM_FAILED";

export const FETCH_MOTOR_CYCLE_COUNTRY = "FETCH_MOTOR_CYCLE_COUNTRY";
export const FETCH_MOTOR_CYCLE_COUNTRY_SUCCESS =
  "FETCH_MOTOR_CYCLE_COUNTRY_SUCCESS";
export const FETCH_MOTOR_CYCLE_COUNTRY_FAILED =
  "FETCH_MOTOR_CYCLE_COUNTRY_FAILED";

export const VECHICLE_ONBOARDING = "VECHICLE_ONBOARDING";
export const VECHICLE_ONBOARDING_SUCCESS = "VECHICLE_ONBOARDING_SUCCESS";
export const VECHICLE_ONBOARDING_FAILED = "VECHICLE_ONBOARDING_FAILED";

export const PENDING_VECHICLE_ONBOARDING = "PENDING_VECHICLE_ONBOARDING";
export const PENDING_VECHICLE_ONBOARDING_SUCCESS =
  "PENDING_VECHICLE_ONBOARDING_SUCCESS";
export const PENDING_VECHICLE_ONBOARDING_FAILED =
  "PENDING_VECHICLE_ONBOARDING_FAILED";

export const VECHICLE_DETAILS = "VECHICLE_DETAILS";
export const VECHICLE_DETAILS_SUCCESS = "VECHICLE_DETAILS_SUCCESS";
export const VECHICLE_DETAILS_FAILED = "VECHICLE_DETAILS_FAILED";

export const RIDERS_REGISTER = "RIDERS_REGISTER";
export const RIDERS_REGISTER_SUCCESS = "RIDERS_REGISTER_SUCCESS";
export const RIDERS_REGISTER_FAILED = "RIDERS_REGISTER_FAILED";

export const FETCH_ONBOARD_USERS = "FETCH_ONBOARD_USERS";
export const FETCH_ONBOARD_USERS_SUCCESS = "FETCH_ONBOARD_USERS_SUCCESS";
export const FETCH_ONBOARD_USERS_FAILED = "FETCH_ONBOARD_USERS_FAILED";

export const ONBOARD_USERS_DETAIL = "ONBOARD_USERS_DETAIL";
export const ONBOARD_USERS_DETAIL_SUCCESS = "ONBOARD_USERS_DETAIL_SUCCESS";
export const ONBOARD_USERS_DETAIL_FAILED = "ONBOARD_USERS_DETAIL_FAILED";

export const FETCH_PRE_REGISTER_USER = "FETCH_PRE_REGISTER_USER";
export const FETCH_PRE_REGISTER_USER_SUCCESS =
  "FETCH_PRE_REGISTER_USER_SUCCESS";
export const FETCH_PRE_REGISTER_USER_FAILED = "FETCH_PRE_REGISTER_USER_FAILED";

export const EXPORT_TO_EXCEL = "EXPORT_TO_EXCEL";
export const EXPORT_TO_EXCEL_SUCCESS = "EXPORT_TO_EXCEL_SUCCESS";
export const EXPORT_TO_EXCEL_FAILED = "EXPORT_TO_EXCEL_FAILED";

export const FETCH_USER_VEHICLES = "FETCH_USER_VEHICLES";
export const FETCH_USER_VEHICLES_SUCCESS = "FETCH_USER_VEHICLES_SUCCESS";
export const FETCH_USER_VEHICLES_FAILED = "FETCH_USER_VEHICLES_FAILED";

export const VECHICLE_ONBOARDING_FROM_MEMBERSHIP =
  "VECHICLE_ONBOARDING_FROM_MEMBERSHIP";
export const VECHICLE_ONBOARDING_FROM_MEMBERSHIP_SUCCESS =
  "VECHICLE_ONBOARDING_FROM_MEMBERSHIP_SUCCESS";
export const VECHICLE_ONBOARDING_FROM_MEMBERSHIP_FAILED =
  "VECHICLE_ONBOARDING_FROM_MEMBERSHIP_FAILED";

export const FETCH_ALL_DEALER = "FETCH_ALL_DEALER";
export const FETCH_ALL_DEALER_SUCCESS = "FETCH_ALL_DEALER_SUCCESS";
export const FETCH_ALL_DEALER_FAILED = "FETCH_ALL_DEALER_FAILED";

export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILED = "FETCH_COUNTRY_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const FETCH_CITY = "FETCH_CITY";
export const FETCH_CITY_SUCCESS = "FETCH_CITY_SUCCESS";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";
